import Factory from '../utils/factory'
import Address from '../Address'
import Publishing from './publishing'

export default Factory({
  id: null,
  media: {
    logo: null,
    logoInverted: null,
    favicon: null,
  },
  name: null,
  theme: {
    template: 'sample',
    primary: '#1d56d8',
    secondary: null,
  },
  address: Address(),
  publishing: Publishing(),
  customFields: null,
  customFieldsConfig: [],
  inject: {
    css: null,
    js: null,
  },
  billing: null,
})
